<kve-editor-content-cell>
    <div class="content-cell">
        <div class="cell-content">
            <div class="input-cell">
                <nb-toggle [checked]="true" labelPosition="start">Facebook</nb-toggle>
            </div>
            <div class="input-cell">
                <nb-toggle [checked]="true" labelPosition="start">Twitter</nb-toggle>
            </div>
            <div class="input-cell">
                <nb-toggle [checked]="true" labelPosition="start">Your Account</nb-toggle>
            </div>
            <div class="input-cell">
                <nb-toggle [checked]="true" labelPosition="start">Your Orders</nb-toggle>
            </div>
        </div>
    </div>
</kve-editor-content-cell>
